{
  "connections.title": "Connected assistants",
  "connections.lede": "See exactly which assistant clients can reach your workspace, reduce their catalogue, or revoke access immediately.",
  "connections.never": "Never",
  "connections.error.generic": "The assistant connection could not be updated. Try again.",
  "connections.connected.title": "Authorized clients",
  "connections.connected.description": "Capability profiles change discovery size, while granted OAuth scopes remain the hard authority boundary.",
  "connections.empty.title": "No assistants are connected",
  "connections.empty.description": "Copy the setup details into an MCP-compatible client. You will review requested scopes during OAuth authorization.",
  "connections.status.active": "Active",
  "connections.status.revoked": "Revoked",
  "connections.lastUsed": "Last used",
  "connections.expires": "Current token expires",
  "connections.profile.label": "Catalogue profile",
  "connections.profile.core.label": "Core",
  "connections.profile.core.description": "Small everyday capture, today, search, and context surface.",
  "connections.profile.workspace.label": "Workspace",
  "connections.profile.workspace.description": "Core plus the tools relevant to the authorized workspaces.",
  "connections.profile.document.label": "Document",
  "connections.profile.document.description": "Read and edit pages and linked records with document-focused tools, within granted OAuth scopes.",
  "connections.profile.full.label": "Full",
  "connections.profile.full.description": "Every operation allowed by the grant, discovered through the paginated catalogue.",
  "connections.scopes.title": "Granted scopes",
  "connections.scopes.description": "Changing the catalogue profile never adds a scope. Reconnect from the client to request additional authority, which you must approve again.",
  "connections.revoke.title": "Revoke {{name}}?",
  "connections.revoke.description": "Access and refresh tokens for this grant stop working. Your independent workspace records remain unchanged.",
  "connections.revoke.action": "Revoke access",
  "connections.reconnect": "Copy reconnect setup",
  "connections.reconnect.description": "Reconnect from the assistant client and approve a new grant.",
  "connections.setup.title": "Connect another assistant",
  "connections.setup.description": "Use OAuth discovery; never paste a personal access token or account password into an assistant.",
  "connections.setup.copy": "Copy setup",
  "connections.setup.copied": "Setup copied",
  "connections.setup.copyError": "The browser could not copy the setup details. Select the text and copy it manually.",
  "connections.setup.exampleOrigin": "https://your-exognitos.example",
  "connections.setup.mcpUrl": "MCP URL: {{url}}",
  "connections.setup.metadataUrl": "Protected resource metadata: {{url}}",
  "connections.setup.clientId": "OAuth client: {{id}}",
  "connections.setup.copyScopeHint": "Authorize only the scopes needed for the assistant's current job.",
  "connections.created": "Connection created",
  "connections.issued": "Current token issued",
  "connections.registration.label": "Registration source",
  "connections.registration.unknown": "Unknown or legacy",
  "connections.registration.manual": "Manually registered client",
  "connections.registration.dcr": "Dynamic client registration",
  "connections.registration.cimd": "Client ID metadata document",
  "connections.scopes.unavailable": "Description unavailable while deployment capabilities are loading.",
  "connections.authority.title": "Standing authority",
  "connections.authority.description": "This deny-only policy can narrow what the connection does unattended. It never adds an OAuth scope or waives preview, confirmation, or recent-authentication requirements.",
  "connections.authority.risks.title": "Unattended risk classes",
  "connections.authority.risks.R0.label": "R0 · Read facts",
  "connections.authority.risks.R0.description": "Allow read-only operations inside the selected workspaces.",
  "connections.authority.risks.R1.label": "R1 · Routine writes",
  "connections.authority.risks.R1.description": "Allow bounded routine writes. R0 is required so write results can be returned.",
  "connections.authority.workspaces.title": "Workspace ceiling",
  "connections.authority.workspaces.planner": "Planner",
  "connections.authority.workspaces.projects": "Projects",
  "connections.authority.workspaces.knowledge": "Knowledge",
  "connections.authority.workspaces.life": "Life",
  "connections.authority.workspaces.analysis": "Analysis",
  "connections.authority.workspaces.extensions": "Extensions",
  "connections.authority.budget.label": "Successful R1 writes per rolling hour",
  "connections.authority.budget.description": "0 blocks unattended writes; 1,000 is the hard ceiling. Derived grants share this connection's budget.",
  "connections.authority.save": "Save standing authority",
  "connections.setup.copyCodex": "Copy Codex config",
  "connections.setup.copySnippet": "Copy snippet",
  "connections.setup.mcpLabel": "MCP endpoint",
  "connections.setup.metadataLabel": "Protected-resource discovery",
  "connections.setup.registration.label": "Live registration mode",
  "connections.setup.registration.dcr": "Dynamic client registration is enabled on this deployment.",
  "connections.setup.registration.cimd": "Dynamic registration is disabled; use a Client ID metadata document or a manually registered client.",
  "connections.setup.registration.unknown": "Registration mode is unavailable while deployment capabilities are loading.",
  "connections.setup.requestedScopes": "Recommended read-only scopes",
  "connections.setup.scopeDetails": "Recommended scope descriptions",
  "connections.setup.capabilitiesUnavailable": "Live capability details could not be loaded. The endpoint and snippets remain copyable; verify registration mode and scope descriptions before authorizing.",
  "connections.setup.guidanceOnly": "Configure the server before starting OAuth. The Claude and VS Code blocks are setup guidance, not recorded compatibility evidence.",
  "connections.setup.scopes": "Requested scopes: {{scopes}}",
  "connections.setup.client.codex": "Codex",
  "connections.setup.client.claude": "Claude Desktop / Claude Code",
  "connections.setup.client.vscode": "VS Code",
  "connections.setup.codex.loginHint": "After saving this TOML, start OAuth from a terminal:"
}
